import { AxiosMethods, GroupsApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';
import {
  Contact,
  Group
} from '@setvi/shared/services/react-query/query/contacts/types';

export enum GroupMutationsKey {
  CREATE_GROUP = 'create_group',
  RENAME_GROUP = 'rename_group',
  DELETE_GROUP = 'delete_group',
  ADD_CONTACT_TO_GROUP = 'add_contact_to_group',
  REMOVE_CONTACT_FROM_GROUP = 'remove_contact_from_group'
}

const dynamicId = ':id';

interface CreateGroupMutationProps {
  Name: Group['Name'];
  Description: Group['Description'];
  Contacts?: Contact['Id'][];
}

export const createGroupMutation = () => ({
  mutationFn: ({
    Name,
    Description = '',
    Contacts = []
  }: CreateGroupMutationProps) =>
    axiosHelper({
      endpoint: GroupsApi.CreateGroup,
      method: AxiosMethods.POST,
      body: { Name, Description, Contacts },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface EditGroupMutationProps {
  Id: Group['Id'];
  Name: Group['Name'];
  Description: Group['Description'];
}

export const editGroupMutation = () => ({
  mutationFn: ({ Id, Name, Description }: EditGroupMutationProps) =>
    axiosHelper({
      endpoint: GroupsApi.EditGroup,
      method: AxiosMethods.PATCH,
      body: { Id, Name, Description },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface DeleteGroupMutationProps {
  ID: Group['Id'][];
}

export const deleteGroupMutation = () => ({
  mutationFn: ({ ID }: DeleteGroupMutationProps) =>
    axiosHelper({
      endpoint: GroupsApi.DeleteGroups,
      method: AxiosMethods.DELETE,
      body: { ID },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface AddContactsToGroupMutationProps {
  GroupID: Group['Id'];
  ContactIds: Contact['Id'][];
}

export const addContactsToGroupMutation = () => ({
  mutationFn: ({ GroupID, ContactIds }: AddContactsToGroupMutationProps) =>
    axiosHelper({
      endpoint: GroupsApi.AddContactsToGroup.replace(
        dynamicId,
        GroupID.toString()
      ),
      method: AxiosMethods.PUT,
      body: { Ids: ContactIds },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface RemoveContactsFromGroupMutationProps {
  groupId: number;
  contactIds: number[];
}

export const removeContactsFromGroupMutation = () => ({
  mutationFn: ({ groupId, contactIds }: RemoveContactsFromGroupMutationProps) =>
    axiosHelper({
      endpoint: GroupsApi.RemoveContactsFromGroup.replace(
        dynamicId,
        groupId.toString()
      ),
      method: AxiosMethods.DELETE,
      body: { Ids: contactIds },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});
